import React from 'react';
import { Link } from 'react-router-dom';

export function Footer() {
  return (
    <footer
      className="w-full text-center px-4 py-5 italic"
      style={{
        fontSize: '11.5px',
        color: 'rgb(var(--overlay) / 0.4)',
        backgroundColor: 'rgb(var(--overlay) / 0.02)',
      }}
    >
      MyCryptoPlanner is a planning and estimation tool. It is not a substitute for professional financial or tax advice.
      <div className="not-italic mt-2 flex items-center justify-center gap-2">
        <Link
          to="/terms"
          className="text-[11px] transition-opacity hover:opacity-80"
          style={{ color: 'rgb(var(--overlay) / 0.4)' }}
        >
          Terms
        </Link>
        <span className="text-[11px]" style={{ color: 'rgb(var(--overlay) / 0.4)' }}>
          ·
        </span>
        <Link
          to="/privacy"
          className="text-[11px] transition-opacity hover:opacity-80"
          style={{ color: 'rgb(var(--overlay) / 0.4)' }}
        >
          Privacy
        </Link>
        <span className="text-[11px]" style={{ color: 'rgb(var(--overlay) / 0.4)' }}>
          ·
        </span>
        <Link
          to="/disclaimer"
          className="text-[11px] transition-opacity hover:opacity-80"
          style={{ color: 'rgb(var(--overlay) / 0.4)' }}
        >
          Disclaimer
        </Link>
        <span className="text-[11px]" style={{ color: 'rgb(var(--overlay) / 0.4)' }}>
          ·
        </span>
        <a
          href="mailto:mycryptoplanner@outlook.com"
          className="text-[11px] transition-opacity hover:opacity-80"
          style={{ color: 'rgb(var(--overlay) / 0.4)' }}
        >
          Contact
        </a>
      </div>
      <div className="not-italic mt-2 text-[11px]" style={{ color: 'rgb(var(--overlay) / 0.4)' }}>
        Data provided by{' '}
        <a
          href="https://www.coingecko.com"
          target="_blank"
          rel="noopener noreferrer"
          className="underline-offset-2 transition hover:underline"
          style={{ color: 'rgb(var(--overlay) / 0.4)' }}
        >
          CoinGecko
        </a>
      </div>
    </footer>
  );
}
